import React from "react";
import {injectIntl} from "react-intl";
import LidarSensor from "./LidarSensor";
import {isOVColumnLabel} from "../../../util/LidarTesterUtil";

const BIN_COLUMN_STYLE = (columnLabel, isAnomaly) => {
    return {
        width: isOVColumnLabel(columnLabel) ? "140px" : "70px",
        height: "25px",
        display: "flex",
        border: "0.5px solid black",
        justifyContent: "space-around",
        alignItems: "center",
        background: isAnomaly ? "#000" : "#fff"
    }
}

const Bin = (props) => {

    const {isAnomaly, sensorStates, columnLabel} = props

    const getSensorProps = (index) => {
        return {
            sensorState: sensorStates[index]
        }
    }

    return (
        <div style={BIN_COLUMN_STYLE(columnLabel, isAnomaly)}>
            {!isAnomaly && sensorStates && sensorStates.map((val, i) => (
                <LidarSensor {...getSensorProps(i)}/>
            ))}
        </div>
    )
}

export default injectIntl(Bin);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/lidarTester/Bin.js